import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";

export const realTimeInvoicePdf = "/api/sainc/realTimeInvoicePdf";
export const realTimeCommercialInvoicePdf = "/api/sainc/realTimeInvoicePdf/commercial";
export const realTimeFtaInvoicePdf = "/api/sainc/realTimeInvoicePdf/fta";

export interface RealTimeInvoiceModel {
    invoiceNumber: string;
}

export async function realTimeInvoice(parameter: {
    invoiceNumber: string;
    isInternational: boolean;
}): Promise<ServiceResult<RealTimeInvoiceModel>> {
    try {
        const realTimeInvoiceModel = parameter.isInternational
            ? await get<RealTimeInvoiceModel>(`${realTimeCommercialInvoicePdf}/${parameter.invoiceNumber}`)
            : await get<RealTimeInvoiceModel>(`${realTimeInvoicePdf}/${parameter.invoiceNumber}`);
        return {
            result: realTimeInvoiceModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
